import React from 'react';
import {
  History,
  ChevronDown,
  ChevronUp,
  Clock,
  Sparkles,
  FileText,
  Image as ImageIcon,
  FileSearch
} from 'lucide-react';

const iconMap = {
  texto: FileText,
  imagen: ImageIcon,
  descripcion: FileSearch
};

const colorMap = {
  texto: 'bg-sky-100 text-sky-700 dark:bg-sky-900/50 dark:text-sky-300',
  imagen: 'bg-purple-100 text-purple-700 dark:bg-purple-900/50 dark:text-purple-300',
  descripcion: 'bg-green-100 text-green-700 dark:bg-green-900/50 dark:text-green-300'
};

const HistoryPanel = ({ generationHistory, showHistory, onToggleHistory, onLoadFromHistory }) => {
  if (generationHistory.length === 0) return null;

  const getTypeIcon = (type) => {
    const Icon = iconMap[type] || Sparkles;
    return <Icon className="w-3 h-3" />;
  };

  const getTypeColor = (type) => colorMap[type] || 'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-200';

  return (
    <div className="mb-3">
      <button
        onClick={onToggleHistory}
        className="flex items-center gap-2 text-sm font-medium text-slate-600 dark:text-slate-300 hover:text-slate-900 dark:hover:text-slate-100 transition-colors"
      >
        <History className="w-4 h-4" />
        Historial de sesión ({generationHistory.length})
        {showHistory ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
      </button>

      {showHistory && (
        <div className="mt-2 space-y-1 max-h-32 overflow-y-auto p-2 bg-slate-50 dark:bg-slate-800/60 rounded-lg border border-slate-200 dark:border-slate-700">
          {generationHistory.map((item) => (
            <div
              key={item.id}
              onClick={() => onLoadFromHistory(item)}
              className="flex items-start gap-2 p-2 hover:bg-white dark:hover:bg-slate-700 rounded cursor-pointer transition-colors group"
            >
              <div className={`p-1 rounded ${getTypeColor(item.type)}`}>
                {getTypeIcon(item.type)}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs text-slate-600 dark:text-slate-300 truncate">
                  {item.prompt.substring(0, 60)}...
                </p>
                <div className="flex items-center gap-1 mt-0.5">
                  <Clock className="w-2.5 h-2.5 text-slate-400" />
                  <span className="text-[10px] text-slate-400">
                    {new Date(item.timestamp).toLocaleTimeString()}
                  </span>
                </div>
              </div>
              <div className="text-xs text-slate-400 group-hover:text-sky-600 dark:group-hover:text-sky-400">
                Cargar
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default HistoryPanel;
